import classNames from 'class-names';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';

import Icon from '../../../Atoms/Icon/Icon';

import { getAltBackupPortIcons } from './connection';
import Content from './Content';
import styles from './wan.module.css';

const Others = ({ port, connectionStatus, children, name }) => {
  const child = children && children.find((node) => node.key === name);
  return (
    <Row>
      <Col xl={2}>
        <Content
          icon={
            <Icon
              className={classNames(styles.iconMd)}
              name={getAltBackupPortIcons(connectionStatus)}
            />
          }
          line1={port || '---'}
          line2={connectionStatus || '---'}
          line2ClassName="text-gray-500 text-uppercase"
        />
      </Col>
      <Col className="col pt-3 pb-5 py-sm-0 text-center text-xl-right">
        {child}
      </Col>
    </Row>
  );
};

Others.propTypes = {
  connectionStatus: PropTypes.string,
  port: PropTypes.string,
  children: PropTypes.node,
  name: PropTypes.string,
};

export default Others;
